import { action, makeObservable, observable } from 'mobx'

/** Ключ у localStorage: 'collapsed' | 'expanded' */
export const SIDEBAR_STORAGE_KEY = 'autostrada.sidebar'

function readStoredCollapsed(): boolean {
    try {
        return window.localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'collapsed'
    } catch {
        return false
    }
}

/**
 * Стан сайдбара адмінки (згорнутий/розгорнутий). Вибір користувача живе в
 * localStorage, як і тема, тож переживає перезавантаження. Стосується лише
 * ручного згортання на десктопі: планшет згортає меню сам, мобільний має Drawer.
 */
export class SidebarStore {
    collapsed: boolean

    constructor() {
        this.collapsed = readStoredCollapsed()
        makeObservable(this, { collapsed: observable, setCollapsed: action, toggle: action })
    }

    setCollapsed(collapsed: boolean): void {
        this.collapsed = collapsed
        try {
            window.localStorage.setItem(SIDEBAR_STORAGE_KEY, collapsed ? 'collapsed' : 'expanded')
        } catch {
            // приватний режим або заблоковані дані сайту: стан живе до перезавантаження
        }
    }

    toggle(): void {
        this.setCollapsed(!this.collapsed)
    }
}

export const sidebarStore = new SidebarStore()
